// extracted by mini-css-extract-plugin
export default {"tabInfoBadge":"OrdersTabs_tabInfoBadge__xubL9"};